import measureCache from './measureCache';

const cacheModules = {
    measureCache,
};
export default cacheModules;
